module.exports = __webpack_public_path__ + "6582f8a4ecbc3af1cb1ac32e9557a236.MP3";